<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<!--				<b-button class="float-right" variant="info" @click="openCurrencies">Monedas y tipos de cambio</b-button>-->
				<!--				<b-button class="float-right" @click="addRate" >Agregar</b-button>-->
				<h2>{{ this.$t("rates.ratesDestinations") }}</h2>
				<hr />

				<!-- table -->
				<AjaxTable
					id="rates-index-list"
					:columns="modelColumns"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					resource="rates"
					:show-paginator="false"
					:show-resume="false"
					responsive
					disable-session
				>
					<template v-slot:cell(actions)="{item}">
						<div class="text-center">
							<a
								@click="showZone(item)"
								class="btn btn-sm mr-1 btn-warning"
							>
								<md-icon icon="location_on" />
							</a>
						</div>
					</template>
				</AjaxTable>
				<!-- /table -->
			</div>
		</div>
		<Map v-if="showMap" :zone-selected="zoneSelected" v-model="showMap" />
		<SingleCurrency
			ref="singleCurrency"
			:success-callback="successCallback"
			:rate-plans="ratePlans"
		/>
	</MainLayout>
</template>

<script>
import MainLayout from "../layout/MainLayout.vue";
import AjaxTable from "../../helpers/AjaxTable";
import SingleCurrency from "./SingleCurrency";
import Map from "./Map";
export default {
	components: {
		MainLayout,
		AjaxTable,
		Map,
		SingleCurrency
	},
	data() {
		return {
			showMap: false,
			ratePlans: [],
			zoneSelected: null,
			filters: {
				search: ""
			},
			modelColumns: [
				{ key: "zonedAreaName", label: this.$t("rates.area") },
				{ key: "currency", label: this.$t("rates.currency") },
				{ key: "actions", label: this.$t("rates.action") }
			],
			sortBy: "id",
			sortDesc: true
		};
	},
	computed: {},
	watch: {
		showMap(v) {
			if(!v) this.zoneSelected = null;
		}
	},
	methods: {
		openCurrencies() {
			this.$refs["singleCurrency"].loadModel();
		},
		successCallback() {
			this.$root.$emit("bv::refresh::table", "rates-index-list");
		},
		showZone(zone) {
			this.zoneSelected = JSON.parse(JSON.stringify(zone));
			this.showMap = true;
		},
		loadRatePlans() {
			this.$root.api
				.get("/rates")
				.then(res => {
					this.ratePlans = res.data.rows;
				})
				.catch(this.$root.handleRequestError);
		},
		addRate() {
			this.$refs["single"].loadModel(-1);
		},
		statusRate(item) {
			this.$root.showWarning({
				message: this.$t("warnings.desactivateRate"),
				okAction: (event, setLoading, close) => {
					setLoading(true);
					let action = item.active ? "add" : "remove";
					let ids = this.ratePlans
						?.filter(rp => rp.active)
						.map(rp => rp.id);
					this.$root.api
						.put(`/rates`, {
							currentRate: item.id,
							ratePlans: ids,
							action: action
						})
						.then(() => {
							this.$root.showAlert(
								this.$t("global.successUpdate")
							);
							this.$root.$emit(
								"bv::refresh::table",
								"suppliers-index-list"
							);
							this.loadRatePlans();
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		}
	},
	mounted() {
		this.loadRatePlans();
	}
};
</script>
